module.exports = __webpack_public_path__ + "img/sec2_11.2602282d.png";